<template>
<el-row :gutter="24">
  <el-col :span="10">
    <div class="passport-photo-box" >
      <img :src="onJobInfo.img_url" class="photo-img" alt="">
      <input type="file" class="faraway" accept="image/png, image/jpeg" ref="uploadPassportInput" @change="uploadPassport">
      <div class="change-passport-box" @click="selectPassport">
        <img src="../../../assets/imgs/on-job/photo-icon.png" class="icon" alt="">
        <div class="text">替换</div>
      </div>
    </div>
  </el-col>
  <el-col :span="14">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.passport_content.passport_num, message: `请输入正确的护照号`, trigger: 'blur' }
          ]"
          prop="passport_content.passport_num"
        >
          <div class="form-item-label" solt="label">
            护照号
          </div>
          <el-input v-model.trim="onJobInfo.passport_content.passport_num" :maxlength="12" placeholder="请填写"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.passport_content.surname_cn, message: `请输入正确的姓 (中文)`, trigger: 'blur' }
          ]"
          prop="passport_content.surname_cn"
        >
          <div class="form-item-label" solt="label">
            姓 (中文)
          </div>
          <el-input v-model.trim="onJobInfo.passport_content.surname_cn" :maxlength="5" placeholder="请填写"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.passport_content.name_cn, message: `请输入正确的名 (中文)`, trigger: 'blur' }
          ]"
          prop="passport_content.name_cn"
        >
          <div class="form-item-label" solt="label">
            名 (中文)
          </div>
          <el-input v-model.trim="onJobInfo.passport_content.name_cn" :maxlength="10" placeholder="请填写"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.passport_content.surname_pinyin, message: `请输入正确的姓 (拼音)`, trigger: 'blur' }
          ]"
          prop="passport_content.surname_pinyin"
        >
          <div class="form-item-label" solt="label">
            姓 (拼音)
          </div>
          <el-input v-model.trim="onJobInfo.passport_content.surname_pinyin" :maxlength="40" placeholder="请填写"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.passport_content.name_pinyin, message: `请输入正确的名 (拼音)`, trigger: 'blur' }
          ]"
          prop="passport_content.name_pinyin"
        >
          <div class="form-item-label" solt="label">
            名 (拼音)
          </div>
          <el-input v-model.trim="onJobInfo.passport_content.name_pinyin" :maxlength="60" placeholder="请填写"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.passport_content.birthday, message: `请输入正确的出生日期`, trigger: 'change' }
          ]"
          prop="passport_content.birthday"
        >
          <div class="form-item-label" solt="label">
            出生日期
          </div>
          <el-date-picker
            :value="onJobInfo.passport_content.birthday"
            type="date"
            placeholder="选择日期"
            @input="handleChangeDate($event, 'birthday')"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label=""
          :rules="[
            { pattern: checkConfig.passport_content.sex, message: `请输入正确的性别`, trigger: 'blur' }
          ]"
          prop="passport_content.sex"
        >
          <div class="form-item-label" solt="label">
            性别
          </div>
          <el-radio-group v-model="onJobInfo.passport_content.sex" >
            <el-radio :label="0">男</el-radio>
            <el-radio :label="1">女</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>

  </el-col>
</el-row>
</template>

<script>
import moment from 'moment';
import uploadFileService from '../../../services/upload-file-service.js';

export default {
  props: {
    onJobInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    checkConfig: {
      type: Object,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    // 选择护照
    selectPassport() {
      this.$refs.uploadPassportInput.click();
    },
    // 上传护照
    uploadPassport(e) {
      const files = e.target.files;
      const file = files[0];
      if (!file) return;

      // 上传前校验文件类型
      if (['image/jpeg', 'image/png'].indexOf(file.type) === -1) {
        this.$message.error('护照识别失败，请检查后重新上传');
        e.target.value = '';
        return;
      }

      const loadingIns = this.$loading();

      // 识别护照
      uploadFileService.uploadOcrMaterial(file, 'passport', { noToast: true, zipImg: true }).then((res) => {
        // 识别成功
        loadingIns.close();
        e.target.value = '';
        // 存在不是护照
        if (!res.passport_number) {
          this.$message.error('护照识别失败，请检查后重新上传');
        } else {
          this.onJobInfo.img_url = res.url || '';
          this.onJobInfo.passport_content = {
            passport_num: res.passport_number || '',
            surname_cn: res.surname_cn || '',
            surname_pinyin: res.surname_pinyin || '',
            name_cn: res.name_cn || '',
            name_pinyin: res.name_pinyin || '',
            birthday: res.birthday || '',
            sex: [0, 1].indexOf(res.gender) > -1 ? res.gender : '',
            key: res.temp_key || '',
          };
        }
      }).catch(() => {
        this.$message.error('护照识别失败，请检查后重新上传');
        loadingIns.close();
        e.target.value = '';
      });
    },
    handleChangeDate(date, field) {
      if (!date) {
        this.$set(this.onJobInfo.passport_content, field, '');
      } else {
        this.$set(this.onJobInfo.passport_content, field, moment(date).format('YYYY-MM-DD'));
      }
    },
  },
};
</script>

<style lang="less" scoped>
.passport-photo-box{
  width: 100%;
  position: relative;
  font-size: 0;
  min-height: 200px;
  &:hover{
    .change-passport-box{
      display: flex;
    }
  }
  .photo-img{
    width: 100%;
  }

  .change-passport-box{
    position: absolute;
    right: 12px;
    bottom: 12px;
    width: 78px;
    height: 36px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    display: none;
    .icon{
      width: 14px;
      height: 14px;
    }
    .text{
      margin-left: 4px;
      font-size: 14px;
      color: #fff;
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/pages/on-job/components/edit-form-passport.vue